import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Header.css'; // Common header styles

const Header = () => {
    return (
        <header className="header">
            <div className="logo-container">
                <img
                    src="https://i.ibb.co/gZY4ySv/dd978ca4-6fa3-40fa-9dce-111e5d406b9c.webp"
                    alt="SaaS Business Logo"
                    className="logo"
                />
                <div className="logo-text">Nexyra Teach SaaS</div>
            </div>
            <nav>
                <ul className="main-nav">
                    <li><Link to="/">Home</Link></li>
                    <li><a href="/#features">Features</a></li>
                    <li><a href="/#pricing">Pricing</a></li>
                    <li><a href="/#benefits">Benefits</a></li>
                    <li><a href="/#how-it-works">How It Works</a></li>
                    <li><a href="/#customer-reviews">Customer Reviews</a></li>
                    <li><a href="/#team">Team</a></li>
                    <li><a href="/#contact">Contact</a></li>
                </ul>
                <ul className="auth-nav">
                    <li><Link to="/login">Login</Link></li>
                    <li><Link to="/register">Register</Link></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
